import endpoints from "@config/endpoints";
import { child_tracking_message } from "@constants/childTrackingConstant";
import { getData, postDataJSON} from "@services/CommonApiService";
import { errorLogger } from "@utils/applicationLogUtils";
import { encodeWithKeyAndShift } from "@utils/base64Utils";
import { toast } from "react-toastify";


export const ServiceListByChildBeneficiaryId = async (childBenefId: any) => {
    try {
        const res = await getData<any>(`${endpoints.getServiceListByChildBenefId}/${childBenefId}`);
        return res.data? res : null;
    } catch (error: any) {
        toast.error(child_tracking_message.errorMessageForGettingInitialDetails, {
            position: "top-center"
        });
        errorLogger(error?.response?.data || error?.response || error);
    };
};